import Header from "@/components/Header";
import Hero from "@/components/Hero";
import AboutSection from "@/components/AboutSection";
import Services from "@/components/Services";
import Reviews from "@/components/Reviews";
import Zones from "@/components/Zones";
import FAQ from "@/components/FAQ";
import CallButton from "@/components/CallButton";
import HelpButton from "@/components/HelpButton";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO 
        title="Serrurier Villeurbanne 24h/7j – Tolstoï Serrurier | Dépannage Express 04 82 53 16 08"
        description="Serrurier d'urgence à Villeurbanne et Grand Lyon : ouverture porte, changement/réparation serrure, volet roulant, porte blindée. Intervention rapide 24h/24 et 7j/7. Quartiers : Charpennes, Gratte-Ciel, République, Cusset. Devis transparent."
        keywords="serrurier Villeurbanne, dépannage serrure urgence, ouverture porte Villeurbanne, serrurier Lyon, changement serrure 69, serrurier 24h Villeurbanne, Tolstoï serrurier, dépannage urgence Lyon, serrurier Charpennes, serrurier Gratte-Ciel"
        canonical="https://www.tolstoi-serrurier.fr/"
        ogUrl="https://www.tolstoi-serrurier.fr/"
        ogImage="https://www.tolstoi-serrurier.fr/logo.jpg"
      />
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <Services />
        <Reviews />
        <Zones />
        <FAQ />
      </main>
      <Footer />
      <CallButton />
      <HelpButton />
    </div>
  );
};

export default Index;
